import { useNavigate } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import useGetFranchiseManagerDetail from "entity/franchise/useGetFranchiseManagerDetail"

import DTStyle from "shared/style/detailTableStyle"
import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const FranchiseManagerDetail = () => {
    const navigate = useNavigate()

    const [franchiseManagerData] = useGetFranchiseManagerDetail()

    

    const franchiseDataList = [
        {
            "label": "IDX",
            "value": franchiseManagerData?.data?.franchise_manager?.franchise_idx
        },
        {
            "label": "대표 주소",
            "value": franchiseManagerData?.data?.franchise_manager?.franchise_address
        },
        {
            "label": "이름",
            "value": franchiseManagerData?.data?.franchise_manager?.franchise_name
        },
        {
            "label": "대표 연락처",
            "value": franchiseManagerData?.data?.franchise_manager?.franchise_name
        },
        {
            "label": "매장 이용권",
            "value": franchiseManagerData?.data?.franchise_manager?.store_ticket_name
        },
    ]
    const franchiseManagerDataList = [
        {
            "label": "IDX",
            "value": franchiseManagerData?.data?.franchise_manager?.idx
        },
        {
            "label": "상태",
            "value": franchiseManagerData?.data?.franchise_manager?.is_approve ? "승인" : "미승인"
        },
        {
            "label": "이름",
            "value": franchiseManagerData?.data?.franchise_manager?.name
        },
        {
            "label": "연락처",
            "value": franchiseManagerData?.data?.franchise_manager?.contact
        },
        {
            "label": "가입 날짜",
            "value": timestampCalculator(franchiseManagerData?.data?.franchise_manager?.created_at)
        },
    ]
    const logoImg = franchiseManagerData?.data?.franchise_manager?.franchise_logo_img

    const sizeList = ["short", "long", "long", "expand", "medium", "long"]
    const tableHeadList = ["IDX", "매니저 이름", "매니저 연락처", "매장 이름", "상태", "가입 날짜"]

    return (
        <Style.Wrapper>
            <MainHeader />

            <Style.AreaDiv>
                <h2>프렌차이즈 매니저 정보</h2>
                <DTStyle.TableDiv>
                    {franchiseManagerDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>프렌차이즈 정보</h2>
                <DTStyle.TableDiv>
                    {franchiseDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            {logoImg &&
                <Style.AreaDiv>
                    <h2>로고 이미지</h2>
                    <div>
                        <Style.LogoImg src={logoImg} />
                    </div>
                </Style.AreaDiv>
            }

            <Style.AreaDiv>
                <h2>매장 목록</h2>

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {franchiseManagerData?.data?.store_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1} onClick={() => navigate(`/manager/store/${elem?.idx}/detail`)}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{elem?.contact}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{elem?.store_name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[4]}>{elem?.is_approve ? "승인" : "미승인"}</TStyle.Data>
                            <TStyle.Data $size={sizeList[5]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>
            </Style.AreaDiv>

        </Style.Wrapper >
    )
}

export default FranchiseManagerDetail